var _style, _path, _polygon, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWidget = function SvgWidget(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#909090;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#909090;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#909090;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.8,28.2L27.8,28.2c-1.3,1.3-3.3,1.3-4.6,0L17,22l4.6-4.6l6.2,6.2C29.1,24.8,29.1,26.9,27.8,28.2z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "6.2,3.5 3.2,6.6 5.5,10.5 9.3,12.8 17.8,21.3 20.9,18.2 12.4,9.7 10.1,5.8 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.9,16.1l2.7-2.7c1.9,0.7,4.2,0.4,5.7-1.2c1.5-1.5,1.9-3.8,1.2-5.7l-2.6,2.6l-2.4-0.6l-0.6-2.4l2.6-2.6 c-1.9-0.7-4.2-0.4-5.7,1.2c-1.5,1.5-1.9,3.8-1.2,5.7l-2.7,2.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.7,16.3l-2.3,2.3c-1.9-0.7-4.2-0.4-5.7,1.2c-1.5,1.5-1.9,3.8-1.2,5.7l2.6-2.6l2.4,0.6l0.6,2.4l-2.6,2.6 c1.9,0.7,4.2,0.4,5.7-1.2c1.5-1.5,1.9-3.8,1.2-5.7l2.4-2.4"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWidget, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/widget.add906e1.svg";
export { ForwardRef as ReactComponent };